// src/pages/Login.jsx  (Phase 2 — email + password via Supabase Auth)
import React, { useState } from 'react'
import { useApp } from '../context/AppContext'
import { PasswordInput } from '../components/UI'

export default function Login() {
  const { login } = useApp()
  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [error,    setError]    = useState('')
  const [loading,  setLoading]  = useState(false)

  const attempt = async () => {
    setError('')
    if (!email || !password) { setError('Please enter email and password'); return }
    setLoading(true)
    const { error: err } = await login(email.trim().toLowerCase(), password)
    setLoading(false)
    if (err) {
      setError('Invalid email or password. Try again.')
      setPassword('')
    }
  }

  return (
    <div className="login-page">
      <div className="login-box">
        {/* Logo */}
        <div className="login-logo">
          <div className="logo-icon">
            <i className="ti ti-wallet" aria-hidden="true" />
          </div>
          <div>
            <div className="logo-name">TecFin</div>
            <div className="logo-sub">Personal Finance Tracker</div>
          </div>
        </div>

        <div className="login-title">Welcome back</div>
        <div className="login-sub">Sign in to your TecFin account</div>

        {/* Error */}
        {error && (
          <div className="login-err">
            <i className="ti ti-alert-circle" aria-hidden="true" />
            {error}
          </div>
        )}

        {/* Email */}
        <div className="login-field">
          <label htmlFor="li-email">Email</label>
          <input
            id="li-email"
            className="input"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && attempt()}
            placeholder="you@example.com"
            autoComplete="email"
            autoFocus
          />
        </div>

        {/* Password */}
        <div className="login-field">
          <label htmlFor="li-pass">Password</label>
          <PasswordInput
            id="li-pass"
            value={password}
            onChange={setPassword}
            placeholder="Enter your password"
            onKeyDown={e => e.key === 'Enter' && attempt()}
          />
        </div>

        <button className="login-btn" onClick={attempt} disabled={loading}>
          {loading
            ? <><i className="ti ti-loader-2" aria-hidden="true" style={{ animation: 'spin 1s linear infinite' }} /> Signing in…</>
            : <><i className="ti ti-login" aria-hidden="true" /> Sign in</>
          }
        </button>
      </div>

      <p style={{ marginTop: 16, fontSize: 11, color: 'var(--gray-400)' }}>
        TecFin v2.0 &nbsp;·&nbsp; Phase 2 — Supabase
      </p>

      <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}
